<template>
  <div class="table-responsive">
    <table
      class="table"
      v-bind:class="{ 'spinner-is-visible': isSpinnerVisible }"
    >
      <thead>
        <tr>
          <SortableHeader
            :current-sort="orderBy"
            :sort-by="'LABEL'"
            @sort="reorder"
          >Dashboard</SortableHeader>

          <th
            class="text-end"
            style="width: 180px"
          >Last Synced</th>

          <th data-sorter="false" class="d-none d-md-table-cell"></th>
        </tr>
      </thead>

      <tbody>
        <projectDashboard
          v-for="(item, index) in items"
          v-bind="item"
          :key="item.id"
          :index="index"
          :policy-update="policyUpdate"
          :ref="item.id"
          :selected="isItemMarked(item.id)"
        />
      </tbody>
      <div class="spinner"></div>
    </table>

    <NoRecords 
        label="There is no related dashboards"
      />

      <Pagination
        v-bind="pageInfo"
        entity-type="dashboards"
        @navigate-to="paginate"
      />
  </div>
</template>

<script>
import Grid from "../shared/grid/grid";

import projectDashboard from "./project_dashboard";

export default {
  extends: Grid,

  components: {
    projectDashboard
  },

  props: {
    clientCompanyId: String
  },

  data: function () {
    return {
      items: [],

      grid: "project-dashboards",

      defaultOrderBy: {
        field: "LABEL",
        direction: "ASC"
      },

      orderBy: {
        field: "LABEL",
        direction: "ASC"
      },

      pageInfo: {
        pageSize: 50,
        currentPage: 1,
        totalCount: 0,
        totalPageCount: 0
      },

      isSpinnerVisible: true
    }
  },

  computed: {
    filterParams: function () {
      let params = {
        clientCompanyId: this.clientCompanyId
      };

      return params;
    }
  },

  methods: {
    fetch: function (params, success) {
      app.graphql.get("grid.fulcrumApps",
        params,

        (data) => {
          let projectDashboards = data.data.fulcrumApps,
              pageInfo = projectDashboards.pageInfo;

          success(projectDashboards, pageInfo);
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title: "Something went wrong!",
            message: "Unable to fetch Apps!"
          })
        }
      )
    }
  }
}
</script>
